// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AjGr","left":"styles_left__i7No7"};